import { useEffect } from "react";
import { useLenis } from "@/hooks/useLenis";
import { track } from "@/lib/analytics";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Work from "@/components/site/Work";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Ecosystem from "@/components/site/Ecosystem";
import ArtistDevelopment from "@/components/site/ArtistDevelopment";
import StudioSessions from "@/components/site/StudioSessions";
import RoadmapGenerator from "@/components/site/RoadmapGenerator";
import DJ from "@/components/site/DJJourney";
import Community from "@/components/site/Community";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  useEffect(() => {
    track("page_view", window.location.pathname);
  }, []);

  return (
    <div className="font-body" data-testid="landing-page">
      <div className="grain" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Work />
        <Marquee />
        <About />
        <Ecosystem />
        <ArtistDevelopment />
        <StudioSessions />
        <RoadmapGenerator />
        <DJ />
        <Community />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
